import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Sidebar } from '../../../components/sidebar';
import { EditProfileModal, type Profile } from '../../profiles-tracking/components/edit-profile-modal';
import { PostsTab } from '../../profiles-tracking/components/edit-profile-modal/components';
import { profilesTrackingService } from '../../profiles-tracking/services';
import { useEditProfileModal } from '../../../contexts/useEditProfileModal';
import { useUserStore, canEditSelectedProfile } from '../../../store/user';
import { profileIdDoUsuario } from '../../reviews/services';
import {
  PostsContainer,
  MainContent,
  Header,
  HeaderTop,
  HeaderTitle,
  Title,
  Subtitle,
} from './styles';

/**
 * Postagens do cliente com dados reais do Google: o mesmo painel que a
 * equipe usa na aba Postagens do editor. Até 30/09/2026 esta página mostrava
 * dados de exemplo fixos.
 */
export const PostsPage: React.FC = () => {
  const { isOpen: isEditModalOpen, closeModal } = useEditProfileModal();
  const [profileData, setProfileData] = useState<Profile | null>(null);
  const { user } = useUserStore();
  const canEdit = canEditSelectedProfile(user);
  const profileId = profileIdDoUsuario(user?.businessProfiles?.[0]);

  useEffect(() => {
    if (user) {
      setProfileData({
        id: user.businessProfiles?.[0] || "1",
        name: user.name || "",
        category: "Cliente",
        status: "active" as const,
        stats: { views: 0, clicks: 0, ranking: 0 },
      });
    }
  }, [user]);

  const handleSaveProfile = async (updatedProfile: Profile) => {
    try {
      await profilesTrackingService.updateProfile(updatedProfile.id, updatedProfile);
      setProfileData(updatedProfile);
      toast.success('Perfil atualizado com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar perfil');
      console.error(error);
      throw error;
    }
  };

  return (
    <PostsContainer>
      <Sidebar />
      <MainContent>
        <Header>
          <HeaderTop>
            <HeaderTitle>
              <Title>Postagens</Title>
              <Subtitle>
                Publique novidades, ofertas e eventos na sua ficha do Google e
                acompanhe o que já está no ar.
              </Subtitle>
            </HeaderTitle>
          </HeaderTop>
        </Header>
        {profileId ? (
          <div style={{ padding: '0 32px 32px' }}>
            <PostsTab
              profile={{
                id: profileId,
                name: user?.name || '',
                category: 'Cliente',
                status: 'active',
                stats: { views: 0, clicks: 0, ranking: 0 },
              }}
              readOnly={!canEdit}
            />
          </div>
        ) : (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#5F6368' }}>
            Nenhum perfil selecionado. Escolha um perfil para ver as postagens.
          </div>
        )}
      </MainContent>

      <EditProfileModal
        isOpen={isEditModalOpen}
        profile={profileData}
        onClose={closeModal}
        onSave={handleSaveProfile}
        hideIATab={true}
      />
    </PostsContainer>
  );
};

export default PostsPage;
